module.exports = __webpack_public_path__ + "static/img/A109.55d6e960.jpg";